module.exports = __webpack_public_path__ + "img/SOEs.e398784e.jpg";